<template>
  <div>
    <div class="authFrom">
      <AuthCheckJourney/>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import AuthCheckJourney from "@/components/UserJourney/AuthCheckJourney.vue";

export default {
  components: {AuthCheckJourney},
  computed: {
    ...mapGetters({
      'isLoggedIn': 'getIsLoggedIn'
    })
  },

  mounted() {
    console.log(this.isLoggedIn, '1212')
  }

}
</script>

<style  scoped>


</style>